<template>
    <footer class="footer">
        <v-container>
            <div class="mb-12px mb-lg-24px">
                <v-row align="center">
                    <v-col cols="auto">
                        <router-link to="/en/disclaimer" class="txt txt--xs font-weight-medium white--text">Disclaimer</router-link>
                    </v-col>
                    <v-col cols="auto">
                        <span class="footer__line"></span>
                    </v-col>
                    <v-col cols="auto">
                        <router-link to="/en/privacy-policy" class="txt txt--xs font-weight-medium white--text">Privacy Policy</router-link>
                    </v-col>
                </v-row>
            </div>
            <p class="txt txt--xs grey--text text--lighten-1">© 2025 Sage Law. All Rights Reserved</p>
        </v-container>
    </footer>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
};
</script>

<style scoped>
.footer {
    background-color: #111;
    padding: 40px 0;
}
.footer__line {
    display: block;
    width: 1px;
    height: 12px;
    background-color: rgba(255, 255, 255, 0.15);
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .footer {
        padding: 48px 0;
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
